import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';

const CheckRequiredUpdate: ContainerComponent = ({ children }) => {
    return <>{children}</>;
};

export default CheckRequiredUpdate;
